module.exports = __webpack_public_path__ + "img/border-inner.33a79bfc.svg";